"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FatArrowIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("./constants");
/**
 * Fat Arrow icon
 */
function FatArrowIcon({ size = constants_1.Sizes.Large, ...attrs }) {
    return ((0, jsx_runtime_1.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 20 18", fill: "none", ...attrs, children: (0, jsx_runtime_1.jsx)("path", { d: "M11.7955 4.0478C8.4195 2.6034 4.9095 1.1017 2.6057.1525.9747-.5173-.556 1.1422.2044 2.7318c.2098.4365.487 1.0431.7926 1.7119.5834 1.2764 1.27 2.779 1.7888 3.7565.2701.4999.25 1.0897 0 1.5996-.4246.8591-.9588 2.0094-1.4585 3.0855-.4307.9275-.8358 1.7998-1.123 2.3829-.7703 1.5896.7705 3.2491 2.4014 2.5793 2.2104-.913 5.54-2.3372 8.7958-3.7299 2.6978-1.154 5.345-2.2863 7.2628-3.0882 1.7809-.7498 1.7809-3.309 0-4.0588-1.8218-.7635-4.3067-1.8266-6.8688-2.9228Z" }) }));
}
exports.FatArrowIcon = FatArrowIcon;
//# sourceMappingURL=FatArrowIcon.js.map